import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, Input, OnDestroy } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { merge, Observable, Subscription } from 'rxjs';
import { combineLatest } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, filter, map, startWith, first } from 'rxjs/operators';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { OwnerTypeIdToStringPipe } from '../../pipes/ownerTypeIdToString.pipe';
import { GraphQLConnector, GraphQLFilter, GraphQlQuery, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';


@Component({
  selector: 'evecdr-datatable',
  templateUrl: './evecdr-datatable.component.html',
  styleUrls: ['./evecdr-datatable.component.css'],
  providers: [DatePipe, OwnerTypeIdToStringPipe]
})
export class EveCdrDataTableComponent implements AfterViewInit, OnDestroy {

  

  @ObservableInput()
  @Input("query")
  query$: Observable<GraphQlQuery>;

  minDate;
  maxDate: Date;

  todaysDate: Date = new Date();
  minStartDate = this.todaysDate.setDate(this.todaysDate.getMonth() - 3);

  sourceFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");
  targetFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");
  minDurationFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");
  maxDurationFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");

  minDateTimeDateFilter: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
  minDateTimeTimeFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");

  maxDateTimeDateFilter: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
  maxDateTimeTimeFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");


  computedQuery: Observable<GraphQlQuery>;

  
  

  constructor(
    public graphQlService: IGraphQlService,
    private datePipe: DatePipe,
    private ownerTypeIdToStringPipe: OwnerTypeIdToStringPipe,
    ) {
    const currentDate = new Date();
    this.minDate = currentDate.setMonth(currentDate.getMonth() - 3);
    
  }  

    
  ngAfterViewInit(): void {

    this.computedQuery = combineLatest(this.query$.pipe(filter(query => query != null)),
      this.sourceFilter.pipe(debounceTime(500)),
      this.targetFilter.pipe(debounceTime(500)),
      this.minDurationFilter.pipe(debounceTime(500)),
      this.maxDurationFilter.pipe(debounceTime(500)),
      this.minDateTimeDateFilter.pipe(debounceTime(500)),
      this.minDateTimeTimeFilter.pipe(debounceTime(500)),
      this.maxDateTimeDateFilter.pipe(debounceTime(500)),
      this.maxDateTimeTimeFilter.pipe(debounceTime(500))
    ).pipe(
      map(([query]) => {

        const extraWheres: GraphQLFilter[] = [];

        if (this.sourceFilter.value != "") extraWheres.push({
          path: "sourcePhoneNumber", comparison: GraphQLComparision.CONTAINS, value: this.sourceFilter.value,
          groupedExpressions: [
            { path: "sourcePhoneNumber", comparison: GraphQLComparision.CONTAINS, value: this.sourceFilter.value, connector: GraphQLConnector.OR },
            { path: "sourceOwner", comparison: GraphQLComparision.CONTAINS, value: this.sourceFilter.value, connector: GraphQLConnector.OR }
          ]
        } as GraphQLFilter);

        if (this.targetFilter.value != "") extraWheres.push({
          path: "targetPhoneNumber", comparison: GraphQLComparision.CONTAINS, value: this.targetFilter.value,
          groupedExpressions: [
            { path: "targetPhoneNumber", comparison: GraphQLComparision.CONTAINS, value: this.targetFilter.value, connector: GraphQLConnector.OR },
            { path: "targetOwner", comparison: GraphQLComparision.CONTAINS, value: this.targetFilter.value, connector: GraphQLConnector.OR }
          ]
        } as GraphQLFilter);

        if (this.minDurationFilter.value != "" || this.maxDurationFilter.value != "") {

          const durationGroupedExpressions: GraphQLFilter[] = [];

          if (this.minDurationFilter.value != "") {
            const minDuration = this.minDurationFilter.value.split(":");
            durationGroupedExpressions.push({ path: "duration", comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL, value: (parseInt(minDuration[0]) * 3600) + (parseInt(minDuration[1]) * 60), connector: GraphQLConnector.AND });
          }

          if (this.maxDurationFilter.value != "") {
            const maxDuration = this.maxDurationFilter.value.split(":");
            durationGroupedExpressions.push({ path: "duration", comparison: GraphQLComparision.LESS_THAN_OR_EQUAL, value: (parseInt(maxDuration[0]) * 3600) + (parseInt(maxDuration[1]) * 60) + 59, connector: GraphQLConnector.AND });
          }

          extraWheres.push({
            path: "duration", comparison: GraphQLComparision.EQUAL, value: 0,
            groupedExpressions: durationGroupedExpressions
          } as GraphQLFilter);          
        }

        if (this.minDateTimeDateFilter.value != null || this.minDateTimeTimeFilter.value != "" || this.maxDateTimeDateFilter.value != null || this.maxDateTimeTimeFilter.value != "") {

          
          const startTimeGroupedExpressions: GraphQLFilter[] = [];

          const now = new Date();

          if (this.minDateTimeDateFilter.value != null || this.minDateTimeTimeFilter.value != "") {
            const minDateTime = this.minDateTimeDateFilter.value != null ? new Date(this.minDateTimeDateFilter.value.getTime()) : new Date(now.getFullYear(),now.getMonth() + 1, now.getDate());

            if (this.minDateTimeTimeFilter.value != "") {
              const minDateTimeTimeParts = this.minDateTimeTimeFilter.value.split(":");
              minDateTime.setHours(parseInt(minDateTimeTimeParts[0]));
              minDateTime.setMinutes(parseInt(minDateTimeTimeParts[1]));
            }

            startTimeGroupedExpressions.push({ path: "startTime", comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL, value: minDateTime, connector: GraphQLConnector.AND });
          }



          if (this.maxDateTimeDateFilter.value != null || this.maxDateTimeTimeFilter.value != "") { 
            const maxDateTime = this.maxDateTimeDateFilter.value != null ? new Date(this.maxDateTimeDateFilter.value.getTime()) : new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());

            if (this.maxDateTimeTimeFilter.value != "") {
              const maxDateTimeTimeParts = this.maxDateTimeTimeFilter.value.split(":");
              maxDateTime.setHours(parseInt(maxDateTimeTimeParts[0]));
              maxDateTime.setMinutes(parseInt(maxDateTimeTimeParts[1]));
              
            }
            else {
              maxDateTime.setHours(23);
              maxDateTime.setMinutes(59);
            }

            maxDateTime.setSeconds(59);
            maxDateTime.setMilliseconds(999);
            
            startTimeGroupedExpressions.push({ path: "startTime", comparison: GraphQLComparision.LESS_THAN_OR_EQUAL, value: maxDateTime, connector: GraphQLConnector.AND });
          }

          extraWheres.push({
            path: "startTime", comparison: GraphQLComparision.EQUAL, value: "0",
            groupedExpressions: startTimeGroupedExpressions
          } as GraphQLFilter);
        }

        const computedQuery = Object.assign({}, query, {
          wheres: query.wheres.concat(extraWheres),
        });

        
        return computedQuery;

      })
    );
  }

  ngOnDestroy(): void {
   // this.scrollSubjectSubscription.unsubscribe();
  }


   onExport() {
    this.computedQuery.pipe(
      first()
    ).subscribe(async q => {
  
    let data = "Start Time, Source, Target, Duration\r\n";

let pageIndex = 0;
const pageSize = 20;

// unknown until first request
let totalCount: number | null = null;

while (true) {
  const query = { ...q, page: pageIndex, pageSize };
  const page = await this.graphQlService.getGraphQlResults(query).toPromise();

  const result = page?.data?.[q.dataset];
  const items: any[] = result?.items ?? [];

  // capture totalCount on first pass
  if (totalCount === null) {
    totalCount = Number(result?.totalCount ?? 0);
    if (!Number.isFinite(totalCount) || totalCount <= 0) break; // nothing to do
  }

  // append CSV rows
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    data += `${this.datePipe.transform(item.startTime, 'dd/MM/yyyy HH:mm:ss')},`;

    if (item.sourceOwnerId != null) {
      data += `${this.ownerTypeIdToStringPipe.transform(item.sourceOwnerTypeId) ?? ""}:${item.sourceOwner},`;
    } else {
      data += `${item.sourcePhoneNumber},`;
    }

    if (item.targetOwnerId != null) {
      data += `${this.ownerTypeIdToStringPipe.transform(item.targetOwnerTypeId) ?? ""}:${item.targetOwner},`;
    } else {
      data += `${item.targetPhoneNumber},`;
    }

    data += `${item.duration}\r\n`;
  }

  pageIndex++;

  // stop conditions:
  const fetched = pageIndex * pageSize;
  const gotAllByCount = totalCount !== null && fetched >= totalCount;
  const lastPageShort = items.length < pageSize;

  if (gotAllByCount || lastPageShort) {
    break;
  }
}



      var file = new Blob([data], { type: "text/csv" }); 
      var a = document.createElement("a");
      var url = URL.createObjectURL(file);
      a.href = url;
      a.download = "Export.csv";
      document.body.appendChild(a);
      a.click();


    }, err => {

    })


  }


  onClearStartTimeFilter() {
    this.minDateTimeDateFilter.next(null);
    this.minDateTimeTimeFilter.next("");

    this.maxDateTimeDateFilter.next(null);
    this.maxDateTimeTimeFilter.next("");
  }

}
